<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pen
      </v-icon>Update Knowledge Base
    </h2>
    <v-card
      color="#fff"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="dark red"
          @click="updateKnowledgeBase"
        >
          Update
        </v-btn>
        <v-btn
          color="red darken-3"
          @click="$router.go(-1)"
        >
          Cancel
        </v-btn>
      </v-col>
      <v-form ref="form">
        <v-card-title>
          <v-row>
            <v-col
              cols="12"
              lg="9"
            >
              <v-text-field
                v-model="title"
                label="Title*"
                hint="Name for your reference - 'DBSystems'."
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                dense
                @input="createSlug"
              />
              <div
                ref="quillEditor"
                style="height: 400px;"
                class="mb-4"
              />
            </v-col>
            <v-col
              cols="12"
              lg="3"
            >
              <h5>Category <font color="red">
                *
              </font></h5>
              <v-select
                v-model="category"
                outlined
                dense
                :items="categoryLists"
                item-value="id"
                item-text="name"
              />
              <v-btn
                x-small
                @click="openFormToCreateCategories"
              >
                + Add new category
              </v-btn>
              <!-- <h5>Tags</h5>
            <v-select
              v-model="tags"
              outlined
              dense
              :items="filteredTags"
              item-value="id"
              item-text="name"
              multiple
              disabled
            />
            <v-btn
              x-small
              @click="openFormToCreateTag"
            >
              + Add new tags
            </v-btn>
            <span
              v-for="tag in kbDetails.tags"
              :key="tag.id"
            >
              <v-chip
                x-small
                outlined
              >
                {{ tag.name }}<span><v-icon
                  small
                  @click="deleteTag(tag)"
                >mdi-close</v-icon>
                </span></v-chip>
            </span> -->
              <h5>Slug <font color="red">
                *
              </font></h5>
              <v-text-field
                v-model="slug"
                outlined
                dense
              />
              <h5>Reading Time</h5>
              <v-text-field
                v-model="readingTime"
                outlined
                disabled
                dense
              />
              <h5>Meta Title <font color="red">
                *
              </font><code>{{ metaTitle.length }}/60</code></h5>
              <v-text-field
                v-model="metaTitle"
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                maxlength="60"
                dense
              />
              <h5>Meta Description <font color="red">
                *
              </font><code>{{ description.length }}/160</code></h5>
              <v-textarea
                v-model="description"
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                maxlength="160"
                dense
              />
            </v-col>
          </v-row>
        </v-card-title>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <create-tags-form
      v-if="openFormToCreateTags"
      @success="fetchTags"
      @closed="openFormToCreateTags = false"
    />
    <create-category-form
      v-if="openFormToCreateCategory"
      @success="fetchCategories"
      @closed="openFormToCreateCategory = false"
    />
    <delete-dialog
      v-if="showDeleteDialog"
      @closed="showDeleteDialog = false"
      @confirmed="confirmTagDelete()"
    />
  </v-container>
</template>
<script>
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  import createTagsForm from './createTagsForm.vue';
  import createCategoryForm from './createCategoryForm.vue';
  import DeleteDialog from '../component/DeleteDialog.vue';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  export default {
    name: 'QuillEditor',
    components: {
      'create-tags-form': createTagsForm,
      'create-category-form': createCategoryForm,
      'delete-dialog': DeleteDialog,
      'centre-spinner': spinner,
    },
    data () {
      return {
        quill: null,
        title: '',
        description: '',
        category: [],
        tags: [],
        content: '',
        metaTitle: '',
        slug: '',
        loading: false,
        readingTime: '',
        openFormToCreateCategory: false,
        openFormToCreateTags: false,
        showDeleteDialog: false,
        tagForDelete: null,
      };
    },
    computed: {
      categoryLists () {
        return this.$store.getters['knowledgebase/getCategory'];
      },
      tagsLists () {
        return this.$store.getters['knowledgebase/getTags'];
      },
      kbDetails () {
        return this.$store.getters['knowledgebase/getKnowledgeBaseDetails'];
      },
      filteredTags () {
        if (this.kbDetails.length !== 0 && Array.isArray(this.kbDetails.tags)) {
          return this.tagsLists.filter(
            tag => !this.kbDetails.tags.some(item => item.id === tag.id),
          );
        } else {
          return [];
        }
      },
      isPublished () {
        return this.kbDetails.knowledge;
      },
    },
    watch: {
      kbDetails () {
        this.setDetails();
      },
      content (newVal, oldVal) {
        this.generateReadingTime();
      },
    },
    mounted () {
      this.quill = new Quill(this.$refs.quillEditor, {
        theme: 'snow',
        placeholder: 'Start writing your text here...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'code', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, false] }],
            ['link', 'image'],
            [{ align: [] }],
          ],
        },
      });
      this.quill.on('text-change', () => {
        this.content = this.quill.root.innerHTML;
      });
      this.fetchCategories();
      this.fetchTags();
      this.fetchKnowledgeBaseDetail(this.$route.params.slug);
    },
    methods: {
      createSlug () {
        if (this.title !== '') {
          this.slug = this.title.replace(/[\s,:;?#_/!@&*()|`$%^+<>]+/g, '-').toLowerCase();
        }
      },
      deleteTag (val) {
        this.tagForDelete = val;
        this.showDeleteDialog = true;
      },
      async confirmTagDelete () {
        await this.$store.dispatch('blogs/deleteTag', {});
      },
      setDetails () {
        this.title = this.kbDetails.knowledge.title;
        this.quill.root.innerHTML = this.kbDetails.knowledge.content;
        this.category = this.kbDetails.knowledge.category.id;
        // this.tags = this.kbDetails.tags;
        this.slug = this.kbDetails.knowledge.slug;
        this.readingTime = this.kbDetails.knowledge.reading_time;
        this.metaTitle = this.kbDetails.knowledge.meta_title;
        this.description = this.kbDetails.knowledge.description;
      },
      async updateKnowledgeBase () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Fill all required fields.',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.content === '') {
          this.$store.dispatch('alert/onAlert', {
            message: 'Write a blog before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.metaTitle.length > 60) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximun 60 character is allowed for meta title',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.description.length > 160) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximum 160 character is allowed for meta description',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('knowledgebase/updateKnowledgeBase', {
          title: this.title,
          description: this.description,
          meta_title: this.metaTitle,
          content: [this.content],
          reading_time: this.readingTime.toString(),
          slug: this.slug,
          category: this.category,
          // tags: this.tags,
          knowledgeId: this.kbDetails.knowledge.id,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Knowledgebase created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$router.go(-1);
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      openFormToCreateTag () {
        this.openFormToCreateTags = true;
      },
      openFormToCreateCategories () {
        this.openFormToCreateCategory = true;
      },
      async fetchCategories () {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchCategory').then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      async fetchTags () {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchTags').then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      async fetchKnowledgeBaseDetail (slug) {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchKnowledgebaseDetails', {
          slug: slug,
        }).then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      generateReadingTime () {
        const wpm = 238;
        const words = this.quill.root.innerText.trim().split(/\s+/).length;
        this.readingTime = Math.ceil(words / wpm);
      },
    },
  };
</script>

<style>
.output {
 margin-top: 20px;
 padding: 10px;
 border: 1px solid #ddd;
 background-color: #f9f9f9;
}
code {
  float: right;
  padding: 0px!important;

}
.theme--light.v-application code{
  background-color: #fff;
}
</style>
